export default __webpack_public_path__ + "media/monsters/03-2ddbb818.png";